import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/b57ec015-25f3-4cac-8677-c517fec21837";
export const REGISTER_URL = "https://a.ntrk2.com/91998c24-b0cd-4f2c-93dc-6c5aa334d7bd";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://winluck.kzw2a.com/download?openExternalBrowser=1&id=qhuh32yewlf4p86";

export * from "./codes";
export * from "./context";
